import template from './enquirySourceTile.html';
import controller from './enquirySourceTileCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    myParam: '<',
  },
};
